// extracted by mini-css-extract-plugin
module.exports = {"detailList":"ReservationItemSectionItemChildren-Jtails_detailList_3PARE","isStyleDingBeauty":"ReservationItemSectionItemChildren-Jtails_isStyleDingBeauty_3com3"};